// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const AlertInfo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
            <path
                fill="#1056AC"
                d="M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-1.406-6.188h.843v-2.25H6.75V8.126h3.375V12.063h1.125v1.687h-4.5v-1.688h.844ZM10.125 7h-2.25V4.75h2.25V7Z"
            />
        </svg>
    );
};

export default React.memo(AlertInfo);
